<template>
  <div class="welcome-container">
    <div class="flex">
      <el-card class="left-col">
        <div class="title">欢迎回来，{{ userJobInfo.userName }}</div>
        <el-row style="margin-top: 40px;">
          <el-col :span="6" v-for="(item,index) in list" :key="index" style="padding-left: 30px;">
            <gameTransactionBackview :itemData="item" :key="index"></gameTransactionBackview>
          </el-col>
        </el-row>
      </el-card>
      <div class="calendar-card">
        <div class="calendar-header">
          <span class="arrow" @click="prevMonth">&lt;</span>
          <span class="year-month">{{ year }} 年 {{ month + 1 }} 月</span>
          <span class="arrow" @click="nextMonth">&gt;</span>
        </div>
        <div class="week-row">
          <span class="week-cell" v-for="(w, i) in weekDays" :key="i">{{ w }}</span>
        </div>
        <div class="date-grid">
          <div class="date-row" v-for="(row, ri) in dateRows" :key="ri">
            <span
              class="date-cell"
              v-for="(d, di) in row"
              :key="di"
              :class="{ 'other-month': d.other, 'today': d.today }"
            >{{ d.day }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-card style="margin-top: 15px;" v-if="steps.length">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">SPBCN个人赛</span>
        </el-col>
      </el-row>
      <div class="progress-steps-row">
          <div
          v-for="(step, index) in steps"
          :key="index"
          class="step-col"
          :class="{
              'step-finish': stepIndex > index,
              'step-current': stepIndex === index,
              'step-pending':stepIndex < index
          }"
          >
              <div class="step-inner" :class="{first: index === 0, last: index === steps.length - 1}">
                  <div class="step-title">
                    <i v-if="stepIndex > index" class="el-icon-success"></i>
                    <i v-if="stepIndex === index" class="el-icon-upload"></i>
                    {{ step.scheduleFlagName }}
                  </div>
                  <!-- <div class="step-desc">{{ step.desc }}</div> -->
                  <div class="step-date">{{ step.date || '未开始' }}</div>
              </div>
          </div>
      </div>
    </el-card>
    <el-row :gutter="15">
      <el-col :span="6">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">待处理</span>
            </el-col>
          </el-row>
          <div class="card" v-for="(item, index) in auditList" :key="index">
            <div class="d1">{{ item.productName }}</div>
            <div class="d2">
              <div>一级部门</div>
              <el-tag type="primary" size="small" effect="dark">待审批</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.creator }}</div>
              <div class="d3">{{ item.createTime }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">我发起的流程</span>
            </el-col>
          </el-row>
          <el-empty description="暂无相关信息" :image-size="80"></el-empty>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">处理中的流程</span>
            </el-col>
          </el-row>
          <!-- <el-empty description="暂无相关信息" :image-size="80"></el-empty> -->
          <div class="card card2" v-for="(item, index) in auditList" :key="index">
            <div class="d1">{{ item.productName }}</div>
            <div class="d2">
              <div>一级部门</div>
              <el-tag type="warning" size="small" effect="dark">处理中</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.creator }}</div>
              <div class="d3">{{ item.createTime }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">超时流程</span>
            </el-col>
          </el-row>
          <!-- <el-empty description="暂无相关信息" :image-size="80"></el-empty> -->
          <div class="card card1" v-for="(item, index) in auditList" :key="index">
            <div class="d1">{{ item.productName }}</div>
            <div class="d2">
              <div>一级部门</div>
              <el-tag type="danger" size="small" effect="dark">已超时</el-tag>
            </div>
            <div class="d2">
              <div class="d3">{{ item.creator }}</div>
              <div class="d3">{{ item.createTime }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      stepIndex: 1,
      steps: [
        // { title: '新赛季启动', desc: '项目组', date: '2026/06/01' },
        // { title: '城市初选', desc: '品牌研发部', date: '8月-9月' },
        // { title: '城市复选', desc: '项目组', date: '9月-11月' },
        // { title: '城市决选/网络决选', desc: '设计部', date: '12月-2月' },
        // { title: '全国总决选', desc: '项目组', date: '3月-4月' }
        // { title: '确认发布', desc: '品牌研发部', date: '' }
      ],
      userJobInfo: '',
      username: window.sessionStorage.getItem('username'),
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      weekDays: ['日', '一', '二', '三', '四', '五', '六'],
      list: [
        {
          icon: 'icon-cuoqingdengji',
          title: '待处理流程',
          flag: 'product_management1',
          menuTag: '5',
          number: 1
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '我发起的流程',
          flag: 'product_management1',
          menuTag: '8',
          number: 2
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '处理中的流程',
          flag: 'product_management1',
          menuTag: '4',
          number: 1
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '超时流程',
          flag: 'product_management1',
          menuTag: '6',
          number: 0
        }
      ],
      auditList: [
        { productName: '2026～2027赛季SPBCN个人赛赛程信息', creator: '张三', createTime: '2026-06-01', auditStatus: 0 },
        { productName: '2026～2027赛季 ITSO团体赛', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }

      ]
    }
  },
  computed: {
    dateRows () {
      const firstDay = new Date(this.year, this.month, 1).getDay()
      const daysInMonth = new Date(this.year, this.month + 1, 0).getDate()
      const daysInPrev = new Date(this.year, this.month, 0).getDate()
      const now = new Date()
      const rows = []
      let row = []
      // 上月补位
      for (let i = firstDay - 1; i >= 0; i--) {
        row.push({ day: daysInPrev - i, other: true, today: false })
      }
      // 当月
      for (let d = 1; d <= daysInMonth; d++) {
        const isToday = this.year === now.getFullYear() && this.month === now.getMonth() && d === now.getDate()
        row.push({ day: d, other: false, today: isToday })
        if (row.length === 7) {
          rows.push(row)
          row = []
        }
      }
      // 下月补位
      let next = 1
      while (row.length < 7) {
        row.push({ day: next++, other: true, today: false })
      }
      if (row.length > 0) rows.push(row)
      return rows
    }
  },
  created () {
    this.$store.commit('SET_ACTIVE_MENU_ID', '')
    this.$store.commit('SET_ACTIVE_TOP_MENU_ID', '')
    this.$store.commit('SET_TOP_MENUS', [])
    this.userJobInfo = this.$store.state.userJobInfo
    // console.log(this.userJobInfo)
    this.getTabList()
  },
  methods: {
    prevMonth () {
      if (this.month === 0) { this.year--; this.month = 11 } else { this.month-- }
    },
    nextMonth () {
      if (this.month === 11) { this.year++; this.month = 0 } else { this.month++ }
    },
    getTabList () {
      this.$http.get('seasonProduct/selectnewtSeasonScheduleBySeason/SPBCN').then(res => {
        if (res.code === 200) {
          res.data.forEach((item, index) => {
            item.date = index === 0 ? item.beginTime : `${item.beginTime} ~ ${item.endTime}`
          })
          this.steps = res.data
          // this.startTime = res.data[0].beginTime
          // this.scheduleList = (res.data || []).filter((item, index) => index !== 0).map(item => ({
          //   beginTime: item.beginTime || '',
          //   endTime: item.endTime || '',
          //   id: item.id || '',
          //   price: item.price || '',
          //   scheduleFlagName: item.scheduleFlagName
          // }))
          // this.currentIndex = res.data.findIndex(item => item.starting)
          // this.chooseIndex = this.currentIndex
          // this.currentTabObj = res.data.find(item => item.starting)
          // const flag = res.data.find(item => item.starting).scheduleFlag
          // this.getDept(flag)
          // if (flag === 'START') {
          //   this.selectStartInfo()
          // }
          // this.chooseFlag = this.steps[this.chooseIndex].scheduleFlag
          // this.getTimeLine()
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bg {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/newerp_icon1.png);
  background-size: auto 90%;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
  position: absolute;
  top: 0;
  right: 0;
}
.txt {
  font-size: 60px;
  font-weight: 600;
  color: #464545;
  padding-bottom: 120px;
}
.h1 {
  font-weight: 400;
  font-size: 40px;
  color: #464545;
  margin-bottom: 20px;
}
.row {
  width: 800px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.flex{
  display: flex;
}
.left-col{
  flex: 1;
  margin-right: 15px;
}
.calendar-card {
  width: 340px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  padding: 16px;
  z-index: 10;
}
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.year-month {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.arrow {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  padding: 0 8px;
  user-select: none;
}
.arrow:hover {
  color: #409eff;
}
.week-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 6px;
}
.week-cell {
  font-size: 12px;
  color: #909399;
  height: 32px;
  line-height: 32px;
}
.date-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.date-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
}
.date-cell {
  font-size: 13px;
  color: #303133;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  cursor: default;
}
.date-cell.other-month {
  color: #c0c4cc;
}
.date-cell.today {
  background: #409eff;
  color: #fff;
  font-weight: bold;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: 0 auto;
}
.title{
  color: #000;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.card{
  margin-bottom: 20px;
  box-shadow: 0 4px 12px 0 rgba(0,0,0,.15);
  background-image: linear-gradient(to right, rgba(64, 150, 255, .5), #fff);
  border-radius: 16px;
  padding: 10px 14px;
  .d1{
    font-size: 14px;
    font-weight: bold;
    height: 40px;
  }
  .d2{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #000;
    margin-top: 10px;
  }
  .d3{
    font-size: 12px;
    font-weight: bold;
    color: #666;
    line-height: 20px;
  }
}
.card1{
  background-image: linear-gradient(to right, rgba(245, 108, 108, .5), #fff);
}
.card2{
  background-image: linear-gradient(to right, rgba(230, 162, 60, .5), #fff);
}

.progress-steps-row {
    display: flex;
    width: 100%;
  }

  .step-col {
    flex: 1;
    position: relative;
    // 卡片之间留空隙
    &:not(:first-child) {
      margin-left: -5px;
    }

    .step-inner {
      background: #E9E9EB;
      padding: 10px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    // ========= Step 标签 =========
    .step-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .step-label {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 6px;

      .step-label-text {
        font-size: 15px;
        color: #909399;
        font-weight: 600;
      }
      .step-label-check {
        font-size: 14px;
        color: #36b34a;
        font-weight: bold;
      }
    }

    // ========= 第一个：左直边，右侧向外斜凸（尖角朝右） =========
    .step-inner.first {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%
      );
    }

    // ========= 中间区块：【左侧向外凸、右侧向外凸】斜边完全平行！重点修复 =========
    .step-inner:not(.first):not(.last) {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%,
        16px 50%
      );
    }

    // ========= 最后一块：左侧向外凸，右直边 =========
    .step-inner.last {
      clip-path: polygon(
        0 0,
        100% 0,
        100% 100%,
        0 100%,
        16px 50%
      );
    }

    .step-circle {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      background: #c0c4cc;
      margin-bottom: 8px;
      flex-shrink: 0;
      margin-left: 5px;
    }

    .step-title {
      font-size: 15px;
      color: #303133;
      font-weight: 500;
      margin-bottom: 4px;
      line-height: 1.4;
    }
    .step-desc {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
    }
    .step-date{
      font-size: 10px;
      color: #666;
    }

    // 状态颜色
    &.step-finish {
      .step-title {
        color: #000;
      }
      .step-inner{
        background-color: #f9d64a;
      }
    }
    &.step-current {
      .step-title {
        color: #1A2B4C;
        font-weight: bold;
      }
      .step-inner{
        background: linear-gradient(140deg, #f9d64a, #fdf4ce);
      }
    }
    &.step-pending {
      .step-title {
        color: #777;
      }
      .step-desc {
        color: #909399;
      }
    }
  }
</style>
